module.exports = __webpack_public_path__ + "assets/img/ability27.2650ab07.png";